// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_z8Y","col":"styles_col__3P7Mw","actions":"styles_actions__31TsQ","conflict":"styles_conflict__QOdyj"};